import React from 'react';
import styled from 'styled-components';
import {CSS_CONSTANTS} from '../css_variables';

const Svg = styled.svg`
/* for some reason colors are faded out  */
	/* path {
		fill: ${props => (props.active ? CSS_CONSTANTS.v2_branding_purple : CSS_CONSTANTS.v2_text_gray)}; 
	} */
	&:hover {
		cursor: pointer;
		path {
			fill: ${CSS_CONSTANTS.v2_branding_purple};
		}
	}
`;

const TimeRegistrationIcon = React.forwardRef(({active, onClick, isPopupVisible}, ref) => (
	<Svg
		ref={ref}
		data-cy="time-registration-popup"
		data-userpilot={'time-registration-popup'}
		className={`${isPopupVisible ? 'active' : ''}  time-registration-icon`}
		onClick={onClick ? onClick : null}
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		active={active}
	>
		<defs>
			<path
				id="a"
				d="M0 8c0 4.412 3.589 8 8 8s8-3.588 8-8-3.589-8-8-8-8 3.588-8 8zm1.778 0A6.23 6.23 0 0 1 8 1.777 6.23 6.23 0 0 1 14.223 8 6.23 6.23 0 0 1 8 14.222 6.23 6.23 0 0 1 1.778 8zm5.333-4.444V8c0 .236.093.461.26.628l2.667 2.667 1.257-1.256-2.406-2.407V3.556H7.111z"
			/>
		</defs>
		<g fill="none" fillRule="evenodd">
			<mask id="b" fill="#fff">
				<use xlinkHref="#a" />
			</mask>
			<path fill={active ? '#6E0FEA' : '#535353'} d="M0 16h16V0H0z" mask="url(#b)" />
		</g>
	</Svg>
));

export default TimeRegistrationIcon;
